module.exports = __webpack_public_path__ + "media/customizations/chathampark/logo-2697781544aee07b37098a90068f3dc0.png";